import React from 'react'

const SearchBar = (props) => (
  <div className="form-field-row type-inlineSearch type-inline-search name-q show-label">
    <div className="form-group">
      <label className="text control-label" htmlFor="q" />
      <div className="controls">
        <div className="field-content content">
          <div className=" input-group input-prepend search-form">
            <span className="input-group-addon">
              <i className="im-search" />
            </span>
            <input
              onChange={props.onChange}
              autoComplete="off"
              className="form-control"
              placeholder={props.placeholder ? props.placeholder: "Search"}
              type="text"
              value={props.value}
            />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default SearchBar
